import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#102235',
    },
    secondary: {
      main: '#f47c20',
    },
    background: {
      default: '#ffffff',
      paper: '#fff',
    },
    text: {
      primary: '#142235',
      secondary: '#576574',
    },
  },
  typography: {
    fontFamily: 'Montserrat, Roboto, Arial, sans-serif',
  },
});

export default theme;
